import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { SceneElement } from '@egr/wcf/modules/core/mdl';
export class DummyElement extends SceneElement {
    // tslint:disable-next-line:cyclomatic-complexity
    constructor(pRoomManager, pRE_reference) {
        let tNode = new TransformNode('dummyElement', pRoomManager.app.model.scene);
        super(pRoomManager.app.model, tNode);
        this.mRoomManager = pRoomManager;
        this.mRE_reference = pRE_reference;
    }
    get type() {
        return (this.mType);
    }
    get RE_reference() {
        return (this.mRE_reference);
    }
    _getType() {
        let tType = this.mType.toString().toLocaleLowerCase();
        return (tType);
    }
    dispose() {
        super.dispose();
    }
    canSelect() {
        return (false);
    }
    clone(pNewParent) {
        return (null);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    serialize(pContext) {
        if (this.mRE_reference != null) {
            const tRE_serialize = this.mRE_reference.serialize(pContext);
            return (tRE_serialize);
        }
        return (null);
    }
}
